/* Candela Montiel — theme.js */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Paneles (menú, carrito, filtros, modal) ---------- */
  var lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-locked');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    var focusable = el.querySelector('button, a, input, select');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closePanel(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(function () { el.hidden = true; }, 280);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .modal:not([hidden])').forEach(closePanel);
  });

  /* ---------- Barra de avisos ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Menú móvil y buscador ---------- */
  var menu = $('[data-menu-drawer]');
  $$('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { openPanel(menu); b.setAttribute('aria-expanded', 'true'); });
  });
  $$('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { closePanel(menu); $$('[data-menu-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); });
  });

  var searchBar = $('[data-searchbar]');
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!searchBar) return;
      searchBar.hidden = !searchBar.hidden;
      b.setAttribute('aria-expanded', String(!searchBar.hidden));
      if (!searchBar.hidden) { var input = $('input[type="search"]', searchBar); if (input) input.focus(); }
    });
  });

  /* ---------- Carrito lateral ---------- */
  function cartDrawer() { return $('[data-cart-drawer]'); }

  function bindCartDrawer() {
    var drawer = cartDrawer();
    if (!drawer) return;
    $$('[data-cart-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { closePanel(cartDrawer()); });
    });
  }
  bindCartDrawer();

  if (!document.body.classList.contains('template-cart')) {
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openPanel(cartDrawer()); });
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
  }

  function refreshCartDrawer(open) {
    return fetch(window.location.pathname + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var wasOpen = cartDrawer() && cartDrawer().classList.contains('is-open');
        var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = html.querySelector('[data-cart-drawer]');
        var current = cartDrawer();
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          bindCartDrawer();
          if (wasOpen || open) {
            current.hidden = false;
            current.classList.add('is-open');
            document.body.classList.add('is-locked');
          }
        }
        return fetch(window.theme.routes.cart + '.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); });
  }

  /* Cambiar cantidades (carrito lateral y página de carrito) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line-change'), 10);
    var qty = Math.max(0, parseInt(btn.getAttribute('data-qty-value'), 10));
    var list = btn.closest('.lines');
    if (list) list.classList.add('is-loading');
    fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      return refreshCartDrawer(true);
    }).catch(function () {
      if (list) list.classList.remove('is-loading');
      alert(window.theme.strings.error);
    });
  });

  /* ---------- Ficha de producto ---------- */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var priceWrap = $('[data-price-wrap] [data-price]', root);
    var errorEl = $('[data-form-error]', root);
    var groups = $$('.variants__group', root);

    /* Galería */
    var main = $('[data-gallery-main]', root);
    function setActiveMedia(id, scroll) {
      if (!main || !id) return;
      var slide = $('[data-media-id="' + id + '"]', main);
      if (!slide) return;
      $$('.gallery__slide', main).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == id); });
      $$('[data-dot]', root).forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-dot') == id); });
      if (scroll) main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
    }
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { setActiveMedia(t.getAttribute('data-thumb'), true); });
    });
    if (main) {
      var ticking = false;
      main.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var index = Math.round(main.scrollLeft / main.clientWidth);
          var slide = $$('.gallery__slide', main)[index];
          if (slide) setActiveMedia(slide.getAttribute('data-media-id'), false);
          ticking = false;
        });
      }, { passive: true });
    }

    /* Últimas unidades (solo con inventario real) */
    var stockEl = $('[data-stock]', root);
    var stockText = $('[data-stock-text]', root);
    var stockStrings = $('[data-stock-strings]', root);
    stockStrings = stockStrings ? JSON.parse(stockStrings.textContent) : null;
    function renderStock(v) {
      if (!stockEl || !stockStrings) return;
      var th = parseInt(stockEl.getAttribute('data-threshold'), 10) || 0;
      var show = v && v.available && v.inv !== null && v.inv > 0 && v.inv <= th;
      if (stockEl.hasAttribute('data-stock-always')) {
        stockEl.hidden = false;
        stockEl.classList.toggle('pp-stock--low', Boolean(show));
        stockEl.classList.toggle('pp-stock--unavailable', !v || !v.available);
        stockText.textContent = !v ? stockStrings.unavailable : !v.available ? stockStrings.soldOut : show ? stockStrings.low : stockStrings.available;
        var count = stockEl.querySelector('[data-stock-count]');
        if (count) {
          count.hidden = !show;
          count.textContent = show ? stockStrings.count.replace('__N__', v.inv) : '';
        }
        return;
      }
      stockEl.hidden = !show;
      if (show) stockText.textContent = (v.inv === 1 ? stockStrings.one : stockStrings.other).replace('__N__', v.inv);
    }

    /* Botón fijo de compra */
    var sticky = $('[data-sticky-buy]', root);
    var stickyPrice = $('[data-sticky-price]', root);
    var stickyAdd = $('[data-sticky-add]', root);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    /* Variantes */
    function selectedOptions() {
      return groups.map(function (g) {
        var checked = $('input:checked', g);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    /* Sin tallas tachadas: todas las opciones se muestran disponibles */
    function markAvailability() {
      $$('.is-unavailable', root).forEach(function (l) { l.classList.remove('is-unavailable'); });
    }
    function setOption(gi, value) {
      var input = groups[gi] && $$('input[data-option-input]', groups[gi]).find(function (i) { return i.value === value; });
      if (input) input.checked = true;
    }
    /* Si la combinación elegida no existe, salta a la más parecida que sí existe (manteniendo lo que se acaba de tocar) */
    function closestVariant(opts, changed) {
      var best = null, bestScore = -1;
      data.variants.forEach(function (v) {
        if (changed > -1 && v.options[changed] !== opts[changed]) return;
        var score = v.options.reduce(function (n, o, i) { return n + (o === opts[i] ? 1 : 0); }, 0) + (v.available ? 0.5 : 0);
        if (score > bestScore) { best = v; bestScore = score; }
      });
      return best;
    }
    /* Foto del color: la de la variante o, si no tiene, la de cualquier variante de ese color */
    var colorIndex = groups.findIndex(function (g) { return g.hasAttribute('data-color-group'); });
    function mediaFor(v, opts) {
      if (v && v.media) return v.media;
      var ci = colorIndex < 0 ? 0 : colorIndex;
      var m = data.variants.find(function (x) { return x.media && x.options[ci] === opts[ci]; });
      return m ? m.media : null;
    }
    function renderPrice(v) {
      if (!priceWrap || !v) return;
      var html = '<span class="price__current">' + v.price + '</span>';
      if (v.compare) {
        html += '<s class="price__compare">' + v.compare + '</s><span class="price__pct">' + window.theme.strings.youSave.replace('__PCT__', v.pct) + '</span>';
      }
      priceWrap.innerHTML = html;
      priceWrap.classList.toggle('price--sale', !!v.compare);
    }
    function onChange(e) {
      var opts = selectedOptions();
      var changed = e && e.target ? groups.indexOf(e.target.closest('.variants__group')) : -1;
      var v = findVariant(opts);
      if (!v && data.variants.length) {
        v = closestVariant(opts, changed);
        if (v) { v.options.forEach(function (o, i) { setOption(i, o); }); opts = selectedOptions(); }
      }
      groups.forEach(function (g, i) { var l = $('[data-option-label]', g); if (l) l.textContent = opts[i] || ''; });
      markAvailability();
      if (errorEl) errorEl.hidden = true;
      var media = mediaFor(v, opts);
      if (media) setActiveMedia(String(media), true);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = window.theme.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      renderPrice(v);
      renderStock(v);
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (stickyAdd) stickyAdd.disabled = !v.available;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    $$('[data-option-input]', root).forEach(function (input) { input.addEventListener('change', onChange); });
    if (groups.length) markAvailability();

    /* Cantidad */
    $$('[data-qty-input]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('[data-step]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
          input.value = next;
        });
      });
    });

    /* Añadir al carrito */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        fetch(window.theme.routes.cartAdd + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        }).then(function (r) {
          return r.json().then(function (body) { return { ok: r.ok, body: body }; });
        }).then(function (res) {
          addBtn.classList.remove('is-loading');
          if (!res.ok) {
            if (errorEl) { errorEl.textContent = res.body.description || window.theme.strings.error; errorEl.hidden = false; }
            return;
          }
          return refreshCartDrawer(true);
        }).catch(function () {
          addBtn.classList.remove('is-loading');
          if (errorEl) { errorEl.textContent = window.theme.strings.error; errorEl.hidden = false; }
        });
      });
    }
  });

  /* ---------- Modal (guía de tallas) ---------- */
  $$('[data-modal-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      var m = document.getElementById(b.getAttribute('data-modal-open'));
      if (m) { lastFocus = b; m.hidden = false; document.body.classList.add('is-locked'); var c = $('[data-modal-close]', m); }
    });
  });
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-modal-close]');
    if (!c) return;
    var m = c.closest('[data-modal]');
    if (m) { m.hidden = true; document.body.classList.remove('is-locked'); if (lastFocus) lastFocus.focus(); }
  });

  /* ---------- Colección: orden y filtros ---------- */
  $$('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  var filtersDrawer = $('[data-filters-drawer]');
  $$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', function () { openPanel(filtersDrawer); }); });
  $$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { closePanel(filtersDrawer); }); });
  $$('[data-filters-form]').forEach(function (filtersForm) {
    var go = function () {
      var params = new URLSearchParams();
      new FormData(filtersForm).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      window.location.href = window.location.pathname + '?' + params.toString();
    };
    filtersForm.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    if (filtersForm.hasAttribute('data-autosubmit')) {
      filtersForm.addEventListener('change', function (e) { if (e.target.type === 'checkbox') go(); });
    }
  });

  /* ---------- Productos relacionados ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var fresh = html.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });
})();
